import { useMemo, useEffect, useState } from 'react';

function useBigVisible() {
  const [visible, setVisible] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setVisible(true);

        setLoading(false);
      }, 300);
    }
  }, [loading]);

  return useMemo(() => {
    return {
      visible,
      loading,
      show: () => setLoading(true),
      hide: () => setVisible(false),
    };
  }, [visible, loading]);
}

export default useBigVisible;
